

























































































































































































































































import {
  SettingManagementListSettingRequest,
  StoreHistoryManagementListOrderRequest,
  StoreHistoryManagementOrderDTO,
  StoreHistoryManagementOrderMetaDTO,
  StoreHistoryManagementStoreHistoryService,
} from "@/common/api";
import { AuthService } from "@/common/api";
import { ORDER_TYPE } from "@/common/constant";
import QCalendar from "@/common/qCalendar.vue";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import StoreHistoryEditComponent from "@/components/admin/storeHistory/storeHistoryEditComponent.vue";
import QChat from "@/components/common/qChat.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import PaginateModel from "@/model/paginate";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const storeHistoryX = namespace("StoreHistory");

@Component({
  name: "StoreHistoryListComponent",
  components: {
    QChat,
    StoreHistoryEditComponent,
    QMultiSelect,
    QCalendar,
    QSearch,
    QPaginate,
    QTableHeader,
  },
})
export default class StoreHistoryListComponent extends Vue {

  get startConfig() {
    return {
      ...this.config,
      ...{
        maxDate: this.request.endDate,
      },
    };
  }

  get endConfig() {
    return {
      ...this.config,
      ...{
        minDate: this.request.startDate,
      },
    };
  }

  get isSelectAll() {
    let check = true;
    for (const history of this.storeHistories) {
      if (!this.selectedHistory.includes(history.id)) {
        check = false;
      }
    }

    return check;
  }
  public storeHistories: StoreHistoryManagementOrderDTO[] = [];
  public meta: StoreHistoryManagementOrderMetaDTO = {
    start: "",
    end: "",
    point: "0",
  };
  public selectedHistory = [];
  public errors = {};
  public connection: WebSocket;
  public connectionId = null;

  public statuses = [
    { id: "initial", name: "未確認" },
    { id: "confirmed", name: "入金待ち" },
    { id: "packing", name: "準備中" },
    { id: "sented", name: "発送済（ポイント付与）" },
    { id: "cancel", name: "キャンセル" },
  ];

  public config = {
    dateFormat: "Y-m-d",
    enableTime: false,
    allowInput: false,
  };

  public request: StoreHistoryManagementListOrderRequest = {
    perPage: 30,
    page: 1,
    keyword: null,
    sort: "created_at",
    direction: StoreHistoryManagementListOrderRequest.direction.DESC,
    status: [],
    code: null,
    name: null,
    startDate: null,
    endDate: null,
  };

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  @storeHistoryX.Action
  public updateIds!: (ids) => void;

  @storeHistoryX.Action
  public updateOrderId!: (id) => void;

  public clearError(name) {
    this.errors = { ...this.errors, ...{ [name]: [] } };
  }

  public selectAll() {
    if (this.isSelectAll) {
      for (const history of this.storeHistories) {
        if (this.selectedHistory.includes(history.id)) {
          const index = this.selectedHistory.indexOf(history.id);
          this.selectedHistory.splice(index, 1);
        }
      }
    } else {
      for (const history of this.storeHistories) {
        if (!this.selectedHistory.includes(history.id)) {
          this.selectedHistory.push(history.id);
        }
      }
    }
  }

  public sort(sort): void {
    if (this.request.sort !== sort) {
      this.request.sort = sort;
      this.request.direction =
        StoreHistoryManagementListOrderRequest.direction.DESC;
    } else {
      this.request.direction =
        this.request.direction ===
        StoreHistoryManagementListOrderRequest.direction.DESC
          ? StoreHistoryManagementListOrderRequest.direction.ASC
          : StoreHistoryManagementListOrderRequest.direction.DESC;
    }

    this.search();
  }

  public mounted() {
    const currentQuery = this.$router.currentRoute.query;

    if (currentQuery.status) {
      const status = currentQuery.status;
      if (typeof status === "string") {
        this.request.status = [currentQuery.status as string];
      } else if (typeof status === "object") {
        this.request.status = currentQuery.status as string[];
      }
    }

    if (currentQuery.direction) {
      this.request.direction = String(
        currentQuery.direction,
      ) as SettingManagementListSettingRequest.direction;
    }

    if (currentQuery.sort) {
      this.request.sort = String(currentQuery.sort);
    }

    if (currentQuery.page) {
      this.request.page = Number(currentQuery.page);
    }

    if (currentQuery.code) {
      this.request.code = String(currentQuery.code);
    }

    if (currentQuery.keyword) {
      this.request.keyword = String(currentQuery.keyword);
    }

    if (currentQuery.name) {
      this.request.name = String(currentQuery.name);
    }

    if (currentQuery.startDate) {
      this.request.startDate = String(currentQuery.startDate);
    }

    if (currentQuery.endDate) {
      this.request.endDate = String(currentQuery.endDate);
    }

    this.init();
  }

  public created() {
    this.connectSocket();
  }

  public init() {
    let query: any = {
      perPage: this.request.perPage,
      page: this.request.page,
      keyword: this.request.keyword,
      sort: this.request.sort,
      direction: this.request.direction,
      code: this.request.code,
      name: this.request.name,
      startDate: this.request.startDate,
      endDate: this.request.endDate,
      status: this.request.status.join(","),
    };

    query = {
      ...query,
      status: this.request.status,
    };

    this.getStoreHistory(query);
  }

  public clearPaginateAndSearch() {
    this.request.page = 1;
    this.search();
  }

  public search(query: any = {}) {
    const newQuery = {
      keyword: this.request.keyword,
      page: this.request.page,
      sort: this.request.sort,
      code: this.request.code,
      name: this.request.name,
      startDate: this.request.startDate,
      endDate: this.request.endDate,
      direction: this.request.direction,
      status: this.request.status,
      ...query,
    };

    this.$router.push({ query: newQuery }).catch(() => {
      //
    });

    query = {
      ...this.request,
      ...query,
    };
    this.getStoreHistory(query);
  }

  public async getStoreHistory(query) {
    const result = await StoreHistoryManagementStoreHistoryService.adminStoreHistory(
      query,
    );

    this.storeHistories = result.data.orders;
    this.meta = result.data.meta;

    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
    });

    this.request.page = result.data.paginator.currentPage;
  }

  public reset() {
    this.request = Object.assign({
      perPage: 30,
      page: 1,
      keyword: null,
      sort: "order_code",
      direction: StoreHistoryManagementListOrderRequest.direction.DESC,
      status: [],
      code: null,
      name: null,
      startDate: null,
      endDate: null,
    });

    this.search();
  }

  public showEditPopup(id = null) {
    (this.$refs.storeHistoryEditPopup as StoreHistoryEditComponent).show(id);
  }

  public async printPdf() {
    const result = await StoreHistoryManagementStoreHistoryService.adminStoreHistoryExportOrder(
      {
        orderIds: this.selectedHistory,
      },
    );

    for (const select_id of this.selectedHistory) {
      const index = this.storeHistories.findIndex(
        (order) => order.id == select_id,
      );
      this.storeHistories[index].is_printed = true;
    }

    window.open(result.data.url, "_blank");
  }

  public printChatPdf(orderId) {
    this.updateOrderId(orderId);
    window.open("/store-history/chat/print", "_blank");
  }

  public openChat(order) {
    (this.$refs.chatComponent as QChat).show(order);
  }

  public convertDateToSlashFormat(date) {
    if (date) {
      return date.replaceAll("-", "/");
    }

    return "";
  }

  public async connectSocket() {
    const result = await AuthService.connectSocketUrl({});
    this.connection = new WebSocket(result.data.connect_socket_url);
    this.connection.addEventListener("message", (event: MessageEvent) => {
      const data = JSON.parse(event.data);
      if (data.action === "subcribe") {
        this.connectionId = data.connectionId;
      } else if (
        data.action === "publish" &&
        this.connectionId !== data.connectionId &&
        data.event === "Refresh" &&
        data?.type &&
        data?.type === ORDER_TYPE.STORE
      ) {
        this.search({ disabledLoadinng: true });
      }
    });
    this.connection.addEventListener("open", () => {
      const body: any = {
        action: "subscribe",
        topic: "admin/notice",
      };

      this.connection.send(JSON.stringify(body));
    });
  }

  public beforeDestroy() {
    if (this.connection) {
      this.connection?.close();
      this.connection = null;
    }
  }
}
